// extracted by css-extract-rspack-plugin
export default {"badge":"t3jF9r8yNsoHDAq_","success":"rEzoOTLI3xw6bAm_","danger":"DO_Qf9cR_EoF2Sbp","neutral":"QrrQhAZBQZ4kJRHY"};